import { defineStore } from "pinia";
import axios from "../utils/axios";
import { ref, watch } from "vue";
import { useAuth } from "./auth";

export const useTelephony = defineStore("telephony", () => {
  const authStore = useAuth();

  const telephonyId = ref<String | null>(null);
  const providerName = ref<String | null>(null);
  const loggedInStaffIsConfigured = ref<boolean>(false);

  async function getConfig() {
    const { data } = await axios.get("/communication/configuration/telephony/settings");
    return data;
  }

  watch(
    () => authStore.selectedTenant,
    async () => {
      if (authStore.isLoggedIn) {
        const data = await getConfig();

        telephonyId.value = data.id;
        providerName.value = data.name;
        loggedInStaffIsConfigured.value = data.loggedInStaffIsConfigured;
      }
    },
    {
      immediate: true,
      flush: "post",
    },
  );

  return {
    telephonyId,
    providerName,
    loggedInStaffIsConfigured,
  };
});
